/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import messages from 'src/shared/app/post-braindate/l10n/postBraindateL10n';
import Notification from 'src/shared/app/notification/component/Notification';

type Props = {
  handleDismiss: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const PostBraindateFeedbackSuccessNotificationDumb = ({
  handleDismiss,
  intl,
}: Props): React.Node => (
  <Notification handleDismiss={handleDismiss} timeout={3000}>
    {intl.formatMessage(messages.successBanner)}
  </Notification>
);

export default compose(
  React.memo,
  injectIntl,
)(PostBraindateFeedbackSuccessNotificationDumb);
